export default __webpack_public_path__ + "static/media/footerlogo.3ca34f68.png";